// workaround, further explained here: https://github.com/twbs/bootstrap/issues/38914#issuecomment-2108123487

import $ from 'jquery';
window.$ = window.jQuery = $;
